export const TOGGLE_CENTER_NOTIFICATION = 'TOGGLE_CENTER_NOTIFICATION';
export const SET_OVERLAY_ACTIVE = 'SET_OVERLAY_ACTIVE';

export const toggleNotification = () => ({
    type: TOGGLE_CENTER_NOTIFICATION
});

export const setOverlayActive = (isActive) => ({
    type: SET_OVERLAY_ACTIVE,
    payload: isActive
});


// WEBPACK FOOTER //
// ./src/actions/centerNotifications.js